import { Link } from "@inertiajs/react";
import ContentLayout from "../shared/ContentLayout";
import PageHeader from "../shared/PageHeader";
import ReferencesSectionCard from "../Reference/ReferencesSectionCard";

interface ReferencesSection {
  id: number;
  title: string;
  description: string | null;
  image_url: string | null;
  text_preview: string | null;
  references: {
    id: number;
    title: string;
    path: string;
    image_url: string | null;
  }[];
}

export default function ReferencesIndex({
  referencesSections
}: {
  referencesSections: ReferencesSection[];
}) {
  const renderBreadcrumbs = () => (
    <div className="breadcrumbs text-sm">
      <ul>
        <li>
          <Link href="/" className="link link-primary">Home</Link>
        </li>
        <li><span>References</span></li>
      </ul>
    </div>
  );

  return (
    <ContentLayout breadcrumbs={renderBreadcrumbs()}>
      <div className="p-3 sm:p-4 max-w-4xl">
        <PageHeader title="References" />
        <div className="flex flex-col gap-4">
          {referencesSections.map((section) => (
            <ReferencesSectionCard
              key={section.id}
              referencesSection={{
                ...section,
                full_path: `/references/${section.id}`
              }}
            />
          ))}
        </div>
      </div>
    </ContentLayout>
  );
}
